import styles from './index.module.scss';
import {useEffect, useRef, useState} from 'react';
import Avatar, {AvatarSize} from '@/components/Avatar';
interface AdminMemberListProps {
    onClose: () => void;
    data?: any;
    duration?: number;
}
export default function AdminMemberList(props:AdminMemberListProps) {
    const {onClose, data} = props;
    const listRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (listRef.current && !listRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div ref={listRef} className={styles.adminListContainer}>
            {
                data && data.length > 0 ? (
                    data.map((item:any, index:any) => {
                        return <div className={styles.userItem} key={item.id}>
                            <Avatar
                                className={styles.avatar}
                                size={AvatarSize.SM}
                                userGuid={item.id}
                            />
                            <div className={styles.userInfo}>
                                <div className={styles.name}>{item.name}</div>
                                <div className={styles.email}>{item.email}</div>
                            </div>
                        </div>;
                    })
                ) : (
                    <div className={styles.noAdminList}>暂无管理员</div>
                )
            }
        </div>
    );
}
